export var isSeparator = function (item) {
  return Object.prototype.hasOwnProperty.call(item, "separator");
};
export var isGroup = function (item) {
  return Object.prototype.hasOwnProperty.call(item, "items");
};
export var isApp = function (item) {
  return !isGroup(item) && !isSeparator(item);
};